/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u30m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thirty minutes of moderate-intensity cardio a day covers a commonly cited activity target and provides real cardiovascular benefit. It doesn't need to be continuous — the same total time split into shorter sessions across the day offers similar benefits.`)
};

const es_timer_u30m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinta minutos de cardio de intensidad moderada al día cubren un objetivo de actividad comúnmente citado y aportan un beneficio cardiovascular real. No necesita ser continuo — el mismo tiempo total dividido en sesiones más cortas a lo largo del día ofrece beneficios similares.`)
};

const de_timer_u30m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dreißig Minuten Cardio mittlerer Intensität pro Tag entsprechen einem häufig genannten Aktivitätsziel und bringen echten kardiovaskulären Nutzen. Es muss nicht am Stück sein — dieselbe Gesamtzeit, über den Tag in kürzere Sessions aufgeteilt, bringt ähnliche Vorteile.`)
};

const nl_timer_u30m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dertig minuten cardio van matige intensiteit per dag dekt een veelgenoemd bewegingsdoel en levert echte cardiovasculaire voordelen op. Het hoeft niet aaneengesloten te zijn — dezelfde totale tijd verdeeld over kortere sessies gedurende de dag biedt vergelijkbare voordelen.`)
};

const fr_timer_u30m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trente minutes de cardio d’intensité modérée par jour correspondent à un objectif d’activité couramment cité et apportent un réel bénéfice cardiovasculaire. Cela n’a pas besoin d’être continu — le même temps total réparti en sessions plus courtes tout au long de la journée offre des bénéfices similaires.`)
};

const it_timer_u30m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenta minuti di cardio a intensità moderata al giorno soddisfano un obiettivo di attività comunemente citato e forniscono un reale beneficio cardiovascolare. Non deve essere continuo — lo stesso tempo totale suddiviso in sessioni più brevi nell'arco della giornata offre benefici simili.`)
};

const pt_br2_timer_u30m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trinta minutos de cardio de intensidade moderada por dia atendem a uma meta de atividade comumente citada e proporcionam benefícios cardiovasculares reais. Não precisa ser contínuo — o mesmo tempo total dividido em sessões mais curtas ao longo do dia oferece benefícios semelhantes.`)
};

const pt_timer_u30m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trinta minutos de cardio de intensidade moderada por dia correspondem a um objetivo de atividade comummente citado e proporcionam um benefício cardiovascular real. Não precisa de ser contínuo — o mesmo tempo total dividido em sessões mais curtas ao longo do dia oferece benefícios semelhantes.`)
};

const ja_timer_u30m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1日30分の中強度有酸素運動は、よく引用される活動目標を満たしており、実際に心血管への効果があります。連続して行う必要はなく、1日を通して短いセッションに分割しても同様の効果が得られます。`)
};

const zh_timer_u30m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每天30分钟中等强度有氧运动符合常见的活动量建议，能带来切实的心血管益处。运动不需要连续进行 — 将同样的总时长拆分成一天中多个较短的时段，也能带来类似的效果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u30m_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u30m_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u30m_faq3_a", locale)
	if (locale === "en") return en_timer_u30m_faq3_a(inputs)
	if (locale === "es") return es_timer_u30m_faq3_a(inputs)
	if (locale === "de") return de_timer_u30m_faq3_a(inputs)
	if (locale === "nl") return nl_timer_u30m_faq3_a(inputs)
	if (locale === "fr") return fr_timer_u30m_faq3_a(inputs)
	if (locale === "it") return it_timer_u30m_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u30m_faq3_a(inputs)
	if (locale === "pt") return pt_timer_u30m_faq3_a(inputs)
	if (locale === "ja") return ja_timer_u30m_faq3_a(inputs)
	return zh_timer_u30m_faq3_a(inputs)
};